<template>
    <div>
        <InitialLoader v-if="showInitialLoader" @closed="onLoaderClosed" />
        <Header />
        <TopVisual />
        <BrandGrid />
        <div v-if="$store.state.hostName !== 'Q'">
            <NewArrival />
            <Ranking />
            <Brand />
            <Footer />
        </div>
    </div>
</template>

<script>
import InitialLoader from '@/components/InitialLoader.vue'
import Header from '@/components/Header.vue'
import TopVisual from '@/components/TopVisual.vue'
import BrandGrid from '@/components/BrandGrid.vue'
import Brand from '@/components/Brand.vue'
import NewArrival from '@/components/NewArrival.vue'
import Ranking from '@/components/Ranking.vue'
import Footer from '@/components/Footer.vue'

const SESSION_KEY = 'rb-initial-loader-done'
const BODY_CLASS = 'is-boot-anim' // InitialLoader 実行中だけ付与

export default {
  name: 'HomeView',

  components: {
    InitialLoader,
    Header,
    TopVisual,
    BrandGrid,
    Brand,
    NewArrival,
    Ranking,
    Footer
  },

  data () {
    return {
      showInitialLoader: false
    }
  },

  created () {
    // 初回のみローダー実行
    if (!sessionStorage.getItem(SESSION_KEY)) {
      this.showInitialLoader = true
      document.body.classList.add(BODY_CLASS)
    }
  },

  methods: {
    onLoaderClosed () {
      this.showInitialLoader = false
      sessionStorage.setItem(SESSION_KEY, '1')
      document.body.classList.remove(BODY_CLASS)
    }
  }
}
</script>
